import React from 'react';
import { Check, Circle } from 'lucide-react';

import { cn } from '../../utils/cn';

export type AssessmentNavStatus = 'none' | 'partial' | 'complete';

export type AssessmentNavStatusIconProps = {
  status: AssessmentNavStatus;
  className?: string;
};

export function AssessmentNavStatusIcon({ status, className }: AssessmentNavStatusIconProps) {
  if (status === 'complete') {
    return (
      <span className={cn('asses-nav-status', 'asses-nav-status--complete', className)} aria-hidden>
        <Check size={12} strokeWidth={3} />
      </span>
    );
  }

  if (status === 'partial') {
    return (
      <span
        className={cn('asses-nav-status', 'asses-nav-status--partial', className)}
        aria-hidden
      >
        <span className="asses-nav-status__partial-fill" />
      </span>
    );
  }

  return (
    <span className={cn('asses-nav-status', 'asses-nav-status--none', className)} aria-hidden>
      <Circle size={16} strokeWidth={1.5} />
    </span>
  );
}

export default AssessmentNavStatusIcon;
